"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLocationReactor = exports.DEBOUNCE_INTERVAL = void 0;
var bernie_core_1 = require("bernie-core");
var React = require("react");
var bernie_client_events_1 = require("../../../events/bernie-client-events");
var logger_1 = require("../../../logger");
var logger = logger_1.ClientLogger.getLoggerWithIdentifier('bernie.client.location-reactor');
exports.DEBOUNCE_INTERVAL = 150;
function withLocationReactor(WrappedComponent, callback, deactivate) {
    var LocationReactor = /** @class */ (function (_super) {
        __extends(LocationReactorWrapper, _super);
        function LocationReactorWrapper(props) {
            var _this = _super.call(this, props) || this;
            _this.componentIsMounted = false;
            _this.state = { location: props.location };
            return _this;
        }
        LocationReactorWrapper.prototype.componentWillUnmount = function () {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            this.componentIsMounted = false;
            if (deactivate) {
                deactivate(this.state.location);
            }
        };
        LocationReactorWrapper.prototype.componentDidMount = function () {
            this.componentIsMounted = true;
            if (this.props.location) {
                this.updateLocation(undefined, this.props.location);
            }
        };
        LocationReactorWrapper.prototype.shouldComponentUpdate = function (nextProps, nextState) {
            if (this.props.location.pathname !== nextProps.location.pathname ||
                this.props.location.hash !== nextProps.location.hash ||
                this.props.location.key !== nextProps.location.key ||
                !LocationReactorWrapper.isQueryEqual(this.props.location.query, nextProps.location.query)) {
                this.updateLocation(this.props.location, nextProps.location);
            }
            return nextState.location !== this.state.location;
        };
        LocationReactorWrapper.isQueryEqual = function (query1, query2) {
            var e_1, _a;
            var query1Keys = Object.keys(query1 || {});
            var query2Keys = Object.keys(query2 || {});
            if (query1Keys.length !== query2Keys.length) {
                return false;
            }
            try {
                for (var query1Keys_1 = __values(query1Keys), query1Keys_1_1 = query1Keys_1.next(); !query1Keys_1_1.done; query1Keys_1_1 = query1Keys_1.next()) {
                    var key = query1Keys_1_1.value;
                    if (!query2Keys.includes(key) || query2[key] !== query1[key]) {
                        return false;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (query1Keys_1_1 && !query1Keys_1_1.done && (_a = query1Keys_1.return)) _a.call(query1Keys_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return true;
        };
        LocationReactorWrapper.prototype.updateLocation = function (prevLocation, location) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    if (this.timeout) {
                        clearTimeout(this.timeout);
                    }
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            _this.timeout = (window || global).setTimeout(function () {
                                callback({ prev: prevLocation, next: location })
                                    .catch(function (error) {
                                    logger.logEvent(bernie_client_events_1.BERNIE_CLIENT_EVENTS.LOCATION_REACTOR_CALLBACK_ERROR, error);
                                    return { query: null };
                                })
                                    .then(function (result) {
                                    var history = _this.props.history;
                                    if (history && location && result && result.query && Object.keys(result.query).length > 0) {
                                        (0, bernie_core_1.updateSearch)({ history: history, location: location, newParams: result.query, replace: result.replace });
                                        resolve(true);
                                    }
                                    else if (_this.componentIsMounted) {
                                        _this.setState({ location: location }, function () {
                                            resolve(true);
                                        });
                                    }
                                    else {
                                        resolve(false);
                                    }
                                })
                                    .catch(reject);
                            }, exports.DEBOUNCE_INTERVAL);
                        })];
                });
            });
        };
        LocationReactorWrapper.prototype.render = function () {
            var _a = this.props, location = _a.location, props = __rest(_a, ["location"]);
            return React.createElement(WrappedComponent, __assign({ location: this.state.location }, props));
        };
        return LocationReactorWrapper;
    }(React.Component));
    LocationReactor.wrappedComponent = LocationReactor;
    return LocationReactor;
}
exports.withLocationReactor = withLocationReactor;
//# sourceMappingURL=location-reactor.js.map